import { ITheme, IStyle, mergeStyleSets, getTheme } from '@fluentui/react';
import React from 'react';
import { SteppedListSection, StepSectionState } from '../../../components/step-section';
import { BwjLinkButton } from '../../../../../framework/components/bwj-link-button';
import { BwjCheckbox } from '../../../../../framework/components/bwj-checkbox';
import { BwjButton, BwjButtonType } from '../../../../../framework/components/bwj-button';

interface IPaymentSectionAcceptTermsProps {
  state: StepSectionState;
  onEditSection: () => void;
  onAdvanceToNextSection: () => void;
  termsAcceptance: TermsReviewState;
  onAcceptanceChanged: (acceptance: TermsReviewState) => void;
  onViewTerms: () => void;
}

export enum TermsReviewState {
  ReviewPending,
  Reviewed,
  Accepted,
}

const getStyleClasses = (theme: ITheme) => {
  const acceptanceActions: IStyle = {
    padding: 0,
    margin: 0,
    marginTop: '0.75rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  };

  return mergeStyleSets({
    acceptanceActions,
  });
}

export const PaymentSectionAcceptTerms: React.FunctionComponent<IPaymentSectionAcceptTermsProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);

  return (
    <SteppedListSection
      id={'stnTerms'}
      title={'Review Terms Of Service'}
      state={props.state}
      formBusy={false}
      onEditSection={props.onEditSection}
    >
      <p>
        <strong>We deliver more than just a door!</strong>&nbsp;
        Professional installation at your home is included with every door you order.  We want to make sure that you are confident in your expectations with this purchase, so to proceed, please take a moment to review our Terms of Service. 
      </p>
      <div>
        <BwjLinkButton
          text={'Review BWJ Storm Terms of Service'}
          icon={'PreviewLink'}
          onClick={props.onViewTerms}
        />
      </div>
      {props.termsAcceptance !== TermsReviewState.ReviewPending &&
      <div className={cs.acceptanceActions}>
        <BwjCheckbox
          id={'cbAccept'}
          label={'I have reviewed and accept the Terms of Service'}
          checked={props.termsAcceptance === TermsReviewState.Accepted}
          onChange={accepted => props.onAcceptanceChanged(accepted ? TermsReviewState.Accepted : TermsReviewState.Reviewed)}
        />
        <BwjButton
          buttonStyle={BwjButtonType.PrimaryStandard}
          text={'Continue'}
          disabled={props.termsAcceptance !== TermsReviewState.Accepted}
          onClick={props.onAdvanceToNextSection}
        />
      </div>}
    </SteppedListSection>
  );
};
